<template>
	<div class="top-sales">
		<b-loading :is-full-page="true" :active.sync="isLoading" :can-cancel="false"></b-loading>
		<h1>Export Product Transfer from Warehouse</h1>
		<div class="content-wrapper">
			<b-field label="Select Shop (optional)">
				<b-autocomplete
					v-model="shopsSuggestions"
					:data="filteredShops"
					:open-on-focus="true"
					placeholder="Shop"
					field="name"
					@select="option => (selectedShop = option)"
					class="shopAutoComplete"
				>
					<template slot="empty">No results found</template>
				</b-autocomplete>
			</b-field>

			<b-field label="Select Brand (optional)" v-if="displayBrandSelection">
				<b-autocomplete
					v-model="brandSuggestions"
					:data="filteredBrands"
					:open-on-focus="true"
					placeholder="Brand"
					field="name"
					@select="option => (selectedBrand = option)"
					class="brandAutocomplete"
				>
					<template slot="empty">No results found</template>
				</b-autocomplete>
			</b-field>

			<div class="datepickerWrapper">
				<b-field label="Starting Date">
					<b-datepicker :date-formatter="dateFormatter" placeholder="Click to select..." v-model="startingDate" icon="calendar-today">
						<button class="button is-primary" @click="startingDate = new Date()">
							<b-icon icon="calendar-today"></b-icon>
							<span>Today</span>
						</button>

						<button class="button is-danger" @click="startingDate = null">
							<b-icon icon="close"></b-icon>
							<span>Clear</span>
						</button>
					</b-datepicker>
				</b-field>

				<b-field label="Ending Date">
					<b-datepicker
						:date-formatter="dateFormatter"
						placeholder="Click to select..."
						v-model="endingDate"
						icon="calendar-today"
						:min-date="minDate"
						:max-date="maxDate"
					>
						<button class="button is-danger" @click="endingDate = null">
							<b-icon icon="close"></b-icon>
							<span>Clear</span>
						</button>
					</b-datepicker>
				</b-field>
			</div>

			<div class="filter-button-wrapper">
				<div class="big-button" @click="submit">EXPORT</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'TopSales',
	data: () => ({
		limit: 100,
		isLoading: false,
		startingDate: null,
		endingDate: null,
		minDate: null,
		maxDate: null,
		shops: [], // For list of shops from API
		shopsSuggestions: '', // For dropdown selection
		selectedShop: null, // Selected shop
		displayBrandSelection: true,
		brands: [], // To store brands
		selectedBrand: null,
		brandSuggestions: '',
		transfers: []
	}),

	watch: {
		startingDate: function(data) {
			if (data !== null) {
				this.minDate = data
				this.maxDate = new Date(data.getFullYear(), data.getMonth(), data.getDate() + 30)

				this.endingDate = data
			} else {
				this.endingDate = null
			}
		}
	},

	mounted: async function() {
		await this.getShops()

		await this.getBrands()
	},

	computed: {
		filteredBrands() {
			return this.brands.filter(option => {
				return (
					option.name
						.toString()
						.toLowerCase()
						.indexOf(this.brandSuggestions.toLowerCase()) >= 0
				)
			})
		},

		filteredShops() {
			return this.shops.filter(option => {
				return (
					option.name
						.toString()
						.toLowerCase()
						.indexOf(this.shopsSuggestions.toLowerCase()) >= 0
				)
			})
		}
	},

	methods: {
		// Get all the brands
		getBrands: async function() {
			const data = {
				limit: 2000,
				sort: {
					name: 'asc'
				}
			}
			const apiGetBrands = await this.$api.getBrand({ data })

			if (apiGetBrands !== undefined) {
				this.brands = apiGetBrands.data.list
			}
		},

		// Get list of shops
		getShops: async function() {
			const apiGetShops = await this.$api.getShops({})

			this.shops = apiGetShops.data.list
		},

		submit: async function() {
			if (this.startingDate == null || this.endingDate == null) {
				this.$swal.fire('Starting and ending dates are required')

				return
			}

			var data = {}
			const createdAt = {}
			this.isLoading = true
			this.transfers = []

			if (this.startingDate !== null) {
				createdAt['$gte'] = this.$moment(this.startingDate)
					.set({ hour: 0 })
					.format('x')
			}

			if (this.endingDate !== null) {
				createdAt['$lte'] = this.$moment(this.endingDate)
					.set({ hour: 24 })
					.format('x')
			}

			data = {
				limit: 1,
				time: {
					createdAt
				}
			}

			if (this.selectedShop && this.selectedShop._id) {
				data.shop = this.selectedShop._id
			}

			if (this.selectedBrand && this.selectedBrand._id) {
				data.brand = this.selectedBrand._id
			}

			const result = await this.$api.getProductTransfer({ data })

			if (result) {
				const total = result.data.total
				const totalLoop = Math.ceil(result.data.total / this.limit)

				this.totalLoop = total

				var i

				for (i = 0; i < totalLoop; i++) {
					const skip = i * this.limit

					const result = await this.getTransfers(skip)

					result.map(item => {
						this.transfers.push(item)
					})
				}
			}

			if (this.transfers.length > 0) {
				this.generateCSV()
				// console.log(this.transfers)
			} else {
				this.$swal.fire('Nothing found!')
				this.isLoading = false
			}
		},

		generateCSV: function() {
			let export_csv = ''

			// Loop data
			this.transfers.map(data => {
				if (data.product.length > 0) {
					export_csv += 'TRANSFER CODE,CREATED DATE,TRANSFER DATE,SHOP,BD CODE,BARCODE,NAME,BRAND NAME,BRAND CODE,ADMIN NAME,QUANTITY,REMARK\r\n'

					let total_quantity = 0

					// Map all the transfer products
					data.product.map(items => {
						const toAdd = [
							data.code,
							this.$moment(data.createdAt).format('DD/MM/YY hh:mm a'),
							this.$moment(data.transfer_date).format('DD/MM/YY'),
							data.shop.name,
							items.product.bd_code,
							items.product.barcode,
							'"' + items.product.name + '"',
							data.brand.name,
							data.brand.code,
							data.author.name,
							items.stock,
							'"' + items.description + '"'
						]

						total_quantity += items.stock

						let row = toAdd.join(',')

						export_csv += row + '\r\n'
					})

					export_csv += ',,,,,,,,,Total,' + total_quantity

					export_csv += '\r\n\r\n'
				}
			})

			this.isLoading = false

			let filename_date = this.$moment().format('DDMMYYhhmmss')

			var csvData = new Blob([export_csv], { type: 'text/csv' }) //new way
			var csvUrl = URL.createObjectURL(csvData)

			var link = document.createElement('a')
			link.setAttribute('href', csvUrl)
			link.setAttribute('download', 'Export_Product_Transfer_' + filename_date + '.csv')
			document.body.appendChild(link) // Required for FF

			link.click()
			link.remove()

			// Reset all the fields
			this.fromDate = null
			this.toDate = null
			this.minDate = null
			this.isLoading = false
		},

		getTransfers: async function(skip = 0) {
			var data = {}
			const createdAt = {}

			if (this.startingDate !== null) {
				createdAt['$gte'] = this.$moment(this.startingDate)
					.set({ hour: 0 })
					.format('x')
			}

			if (this.endingDate !== null) {
				createdAt['$lte'] = this.$moment(this.endingDate)
					.set({ hour: 24 })
					.format('x')
			}

			data = {
				limit: this.limit,
				populate: ['author', 'brand', 'shop', 'warehouse', 'product.product'],
				time: {
					createdAt
				},
				skip
			}

			if (this.selectedShop && this.selectedShop._id) {
				data.shop = this.selectedShop._id
			}

			if (this.selectedBrand && this.selectedBrand._id) {
				data.brand = this.selectedBrand._id
			}

			const result = await this.$api.getProductTransfer({ data })

			if (result) {
				return result.data.list
			}
		},

		// For calender format
		dateFormatter(dt) {
			return dt.toLocaleDateString('en-GB')
		}
	}
}
</script>

<style scoped>
@import '../styles/GeneralStyles.css';
</style>
